<template>
  <div>
    <router-view />
  </div>
</template>
<script>
export default {
  name: "Resources",
};
</script>

<style lang="sass">

/* containers/Resources.vue */
@import '../assets/css/variables.scss'
</style>
